export default [
    {
        "class": "Homeopáticos",
        "systems": [
            "Homeopáticos"
        ]
    },
    {
        "class": "Descongestionante Nasal",
        "systems": [
            "Respiratórios"
        ]
    },
    {
        "class": "Expectorantes",
        "systems": [
            "Respiratórios"
        ]
    },
    {
        "class": "Antitussígenos",
        "systems": [
            "Respiratórios"
        ]
    },
    {
        "class": "Aminoácidos",
        "systems": [
            "Musculoesqueléticos | Articulares"
        ]
    },
    {
        "class": "Manejo da Dirofilariose",
        "systems": [
            "Cardiovasculares",
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Antimicrobianos - Hemoparasitoses",
        "systems": [
            "Antimicrobianos | Antiparasitários",
            "Hematológicos"
        ]
    },
    {
        "class": "Atividade Antiprotozoária",
        "systems": [
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Quelantes Orais de Fósforo",
        "systems": [
            "Manejo Eletrolítico | Solutos Séricos",
            "Renais | Urinários"
        ]
    },
    {
        "class": "Repositores de Cálcio",
        "systems": [
            "Manejo Eletrolítico | Solutos Séricos",
            "Emergência | Intensivismo"
        ]
    },
    {
        "class": "Repositores de Potássio",
        "systems": [
            "Manejo Eletrolítico | Solutos Séricos"
        ]
    },
    {
        "class": "Repositores de Magnésio",
        "systems": [
            "Manejo Eletrolítico | Solutos Séricos"
        ]
    },
    {
        "class": "Antiácidos Orais não Sistêmicos",
        "systems": [
            "Gastrointestinais"
        ]
    },
    {
        "class": "Anti-hiperglicemiantes/Hipoglicemiantes",
        "systems": [
            "Endócrino | Metabolismo"
        ]
    },
    {
        "class": "Hiperglicemiantes não Esteroides",
        "systems": [
            "Manejo Eletrolítico | Solutos Séricos",
            "Endócrino | Metabolismo",
            "Emergência | Intensivismo"
        ]
    },
    {
        "class": "Hormônios Hiperglicemiantes não Esteroides",
        "systems": [
            "Manejo Eletrolítico | Solutos Séricos",
            "Endócrino | Metabolismo"
        ]
    },
    {
        "class": "Sulfonilureias",
        "systems": [
            "Endócrino | Metabolismo"
        ]
    },
    {
        "class": "Fenotiazínicos",
        "systems": [
            "Anestesia | Sedação | Adjuvantes"
        ]
    },
    {
        "class": "Inibidores de Anidrase Carbônica",
        "systems": [
            "Neurológicos | Comportamentais",
            "Renais | Urinários"
        ]
    },
    {
        "class": "Antioxidantes",
        "systems": [
            "Emergência | Intensivismo"
        ]
    },
    {
        "class": "Mucolíticos",
        "systems": [
            "Respiratórios"
        ]
    },
    {
        "class": "Antídotos",
        "systems": [
            "Emergência | Intensivismo"
        ]
    },
    {
        "class": "Anti-inflamatórios não Esteroides",
        "systems": [
            "Analgésicos",
            "Anti-inflamatórios",
            "Musculoesqueléticos | Articulares"
        ]
    },
    {
        "class": "Antifibrinolíticos",
        "systems": [
            "Hematológicos",
            "Cardiovasculares"
        ]
    },
    {
        "class": "Hemostáticos",
        "systems": [
            "Hematológicos",
            "Cardiovasculares"
        ]
    },
    {
        "class": "Coleréticos",
        "systems": [
            "Hepatobiliares"
        ]
    },
    {
        "class": "Hepatoprotetores",
        "systems": [
            "Hepatobiliares"
        ]
    },
    {
        "class": "Dissolução de Cálculos Biliares",
        "systems": [
            "Hepatobiliares"
        ]
    },
    {
        "class": "Ectoparasiticidas",
        "systems": [
            "Dermatológicos Não Tópicos",
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Endoparasiticidas",
        "systems": [
            "Antimicrobianos | Antiparasitários",
            "Gastrointestinais"
        ]
    },
    {
        "class": "Ectoparasiticidas + Endoparasiticidas",
        "systems": [
            "Dermatológicos Não Tópicos",
            "Antimicrobianos | Antiparasitários",
            "Gastrointestinais"
        ]
    },
    {
        "class": "Bloqueadores de Progesterona/Abortivos",
        "systems": [
            "Reprodução | Obstetrícia"
        ]
    },
    {
        "class": "Bifosfonatos",
        "systems": [
            "Musculoesqueléticos | Articulares",
            "Manejo Eletrolítico | Solutos Séricos"
        ]
    },
    {
        "class": "Antianêmicos/Agentes Eritropoiéticos",
        "systems": [
            "Endócrino | Metabolismo",
            "Hematológicos",
            "Cardiovasculares"
        ]
    },
    {
        "class": "Inibidores de Xantina Oxidase",
        "systems": [
            "Renais | Urinários"
        ]
    },
    {
        "class": "Benzodiazepínicos",
        "systems": [
            "Anestesia | Sedação | Adjuvantes"
        ]
    },
    {
        "class": "Antagonistas Benzodiazepínicos",
        "systems": [
            "Anestesia | Sedação | Adjuvantes",
            "Emergência | Intensivismo"
        ]
    },
    {
        "class": "Estimulantes de Apetite",
        "systems": [
            "Neurológicos | Comportamentais"
        ]
    },
    {
        "class": "Manejo de Ansiedade, Fobias e Distúrbios Comportamentais",
        "systems": [
            "Neurológicos | Comportamentais"
        ]
    },
    {
        "class": "Antidepressivos Tricíclicos",
        "systems": [
            "Neurológicos | Comportamentais"
        ]
    },
    {
        "class": "Manejo de Disfunção Cognitiva",
        "systems": [
            "Neurológicos | Comportamentais"
        ]
    },
    {
        "class": "Feromônios",
        "systems": [
            "Neurológicos | Comportamentais"
        ]
    },
    {
        "class": "Antagonistas de NMDA",
        "systems": [
            "Analgésicos",
            "Anestesia | Sedação | Adjuvantes"
        ]
    },
    {
        "class": "Adjuvantes Analgésicos",
        "systems": [
            "Analgésicos",
            "Anestesia | Sedação | Adjuvantes"
        ]
    },
    {
        "class": "Antibióticos: Aminoglicosídeos",
        "systems": [
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Broncodilatadores",
        "systems": [
            "Respiratórios",
            "Emergência | Intensivismo"
        ]
    },
    {
        "class": "Antiarrítmicos",
        "systems": [
            "Emergência | Intensivismo",
            "Cardiovasculares"
        ]
    },
    {
        "class": "Antibióticos: Macrolídeos",
        "systems": [
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Antibióticos: Penicilinas",
        "systems": [
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Antibióticos: Cefalosporinas",
        "systems": [
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Antibióticos: Fluoroquinolonas",
        "systems": [
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Antibióticos: Lincosamidas",
        "systems": [
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Antibióticos: Tetraciclinas",
        "systems": [
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Antibióticos: Carbapenêmicos",
        "systems": [
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Antibióticos: Sulfonamidas",
        "systems": [
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Antibióticos: Glicopeptídeos",
        "systems": [
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Antibióticos: Urinário restrito",
        "systems": [
            "Antimicrobianos | Antiparasitários",
            "Renais | Urinários"
        ]
    },
    {
        "class": "Antibióticos: Nitroimidazólicos",
        "systems": [
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Antibióticos: Diversos",
        "systems": [
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Antifúngicos",
        "systems": [
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Bloqueadores de Canal de Cálcio",
        "systems": [
            "Cardiovasculares"
        ]
    },
    {
        "class": "Anti-hipertensivos/Vasodilatadores",
        "systems": [
            "Cardiovasculares",
            "Renais | Urinários"
        ]
    },
    {
        "class": "Antineoplásicos",
        "systems": [
            "Oncológicos"
        ]
    },
    {
        "class": "Bloqueadores/Antagonistas Adrenérgicos",
        "systems": [
            "Emergência | Intensivismo",
            "Cardiovasculares",
            "Anestesia | Sedação | Adjuvantes"
        ]
    },
    {
        "class": "Antagonistas α-2 Adrenérgicos",
        "systems": [
            "Emergência | Intensivismo",
            "Anestesia | Sedação | Adjuvantes"
        ]
    },
    {
        "class": "Agonistas α-2 Adrenérgicos",
        "systems": [
            "Anestesia | Sedação | Adjuvantes"
        ]
    },
    {
        "class": "Agonistas Adrenérgicos",
        "systems": [
            "Cardiovasculares",
            "Anestesia | Sedação | Adjuvantes",
            "Emergência | Intensivismo",
            "Alergias | Hipersensibilidade"
        ]
    },
    {
        "class": "Bloqueadores Neuromusculares",
        "systems": [
            "Anestesia | Sedação | Adjuvantes"
        ]
    },
    {
        "class": "Anticolinérgicos",
        "systems": [
            "Cardiovasculares",
            "Anestesia | Sedação | Adjuvantes",
            "Emergência | Intensivismo"
        ]
    },
    {
        "class": "Imunossupressores não Esteroides",
        "systems": [
            "Imunossupressores | Imunomoduladores"
        ]
    },
    {
        "class": "Manejo de Retenção Urinária",
        "systems": [
            "Renais | Urinários",
            "Neurológicos | Comportamentais"
        ]
    },
    {
        "class": "Inibidores da Enzima Conversora de Angiotensina (ECA)",
        "systems": [
            "Renais | Urinários",
            "Cardiovasculares"
        ]
    },
    {
        "class": "Antivertiginosos",
        "systems": [
            "Neurológicos | Comportamentais"
        ]
    },
    {
        "class": "Manejo de Atonia de Bexiga",
        "systems": [
            "Renais | Urinários",
            "Neurológicos | Comportamentais"
        ]
    },
    {
        "class": "Hipolipemiantes",
        "systems": [
            "Manejo Eletrolítico | Solutos Séricos",
            "Endócrino | Metabolismo"
        ]
    },
    {
        "class": "Alcalinizantes Séricos",
        "systems": [
            "Manejo Eletrolítico | Solutos Séricos"
        ]
    },
    {
        "class": "Laxantes",
        "systems": [
            "Gastrointestinais"
        ]
    },
    {
        "class": "Fitoterápicos – TGI",
        "systems": [
            "Gastrointestinais"
        ]
    },
    {
        "class": "Antiespasmódicos",
        "systems": [
            "Gastrointestinais"
        ]
    },
    {
        "class": "Antiepilépticos/Anticonvulsivantes",
        "systems": [
            "Neurológicos | Comportamentais",
            "Emergência | Intensivismo"
        ]
    },
    {
        "class": "Barbitúricos",
        "systems": [
            "Anestesia | Sedação | Adjuvantes"
        ]
    },
    {
        "class": "Agonistas Dopaminérgicos",
        "systems": [
            "Reprodução | Obstetrícia"
        ]
    },
    {
        "class": "Antagonistas Dopaminérgicos",
        "systems": [
            "Reprodução | Obstetrícia"
        ]
    },
    {
        "class": "Anti-inflamatórios Esteroides/Corticosteroides",
        "systems": [
            "Anti-inflamatórios",
            "Imunossupressores | Imunomoduladores",
            "Alergias | Hipersensibilidade",
            "Endócrino | Metabolismo"
        ]
    },
    {
        "class": "Anti-inflamatórios Esteroides Inaláveis",
        "systems": [
            "Respiratórios",
            "Anti-inflamatórios"
        ]
    },
    {
        "class": "Diuréticos",
        "systems": [
            "Renais | Urinários",
            "Emergência | Intensivismo",
            "Cardiovasculares"
        ]
    },
    {
        "class": "Anestésicos Locais",
        "systems": [
            "Anestesia | Sedação | Adjuvantes"
        ]
    },
    {
        "class": "Opioides",
        "systems": [
            "Anestesia | Sedação | Adjuvantes",
            "Analgésicos"
        ]
    },
    {
        "class": "Vitaminas",
        "systems": [
            "Endócrino | Metabolismo"
        ]
    },
    {
        "class": "Bloqueadores de Receptores de Angiotensina",
        "systems": [
            "Renais | Urinários",
            "Cardiovasculares"
        ]
    },
    {
        "class": "Anestésicos",
        "systems": [
            "Anestesia | Sedação | Adjuvantes"
        ]
    },
    {
        "class": "Anti-histamínicos H1",
        "systems": [
            "Dermatológicos Não Tópicos",
            "Alergias | Hipersensibilidade"
        ]
    },
    {
        "class": "Anti-histamínicos H2",
        "systems": [
            "Gastrointestinais"
        ]
    },
    {
        "class": "Inibidores de Agregação Plaquetária",
        "systems": [
            "Hematológicos",
            "Cardiovasculares"
        ]
    },
    {
        "class": "Prostaglandinas",
        "systems": [
            "Reprodução | Obstetrícia"
        ]
    },
    {
        "class": "Andrógenos",
        "systems": [
            "Reprodução | Obstetrícia",
            "Endócrino | Metabolismo"
        ]
    },
    {
        "class": "Estrógenos",
        "systems": [
            "Endócrino | Metabolismo",
            "Reprodução | Obstetrícia"
        ]
    },
    {
        "class": "Incontinência Urinária: Estrógeno Responsiva",
        "systems": [
            "Renais | Urinários"
        ]
    },
    {
        "class": "Relaxantes Musculares",
        "systems": [
            "Musculoesqueléticos | Articulares"
        ]
    },
    {
        "class": "Vasopressina e Análogos",
        "systems": [
            "Endócrino | Metabolismo",
            "Renais | Urinários"
        ]
    },
    {
        "class": "Sedativos e Tranquilizantes",
        "systems": [
            "Anestesia | Sedação | Adjuvantes"
        ]
    },
    {
        "class": "Digitálicos",
        "systems": [
            "Cardiovasculares"
        ]
    },
    {
        "class": "Atividade Inotrópica Positiva",
        "systems": [
            "Cardiovasculares",
            "Emergência | Intensivismo",
            "Anestesia | Sedação | Adjuvantes"
        ]
    },
    {
        "class": "Inodilatadores",
        "systems": [
            "Cardiovasculares"
        ]
    },
    {
        "class": "Manejo de Cinetose",
        "systems": [
            "Gastrointestinais",
            "Neurológicos | Comportamentais"
        ]
    },
    {
        "class": "Vasopressores/Anti-hipotensivos",
        "systems": [
            "Emergência | Intensivismo",
            "Anestesia | Sedação | Adjuvantes",
            "Cardiovasculares"
        ]
    },
    {
        "class": "Procinéticos",
        "systems": [
            "Gastrointestinais"
        ]
    },
    {
        "class": "Estimulantes Respiratórios",
        "systems": [
            "Emergência | Intensivismo",
            "Anestesia | Sedação | Adjuvantes",
            "Respiratórios"
        ]
    },
    {
        "class": "Anticoagulantes",
        "systems": [
            "Cardiovasculares",
            "Hematológicos"
        ]
    },
    {
        "class": "Inibidores de Bomba de Prótons",
        "systems": [
            "Gastrointestinais"
        ]
    },
    {
        "class": "Tocolíticos",
        "systems": [
            "Reprodução | Obstetrícia"
        ]
    },
    {
        "class": "Antimicobacterianos",
        "systems": [
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Antivirais",
        "systems": [
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Estimulantes de Colônia Granulocítica",
        "systems": [
            "Hematológicos"
        ]
    },
    {
        "class": "Antiandrogênicos",
        "systems": [
            "Reprodução | Obstetrícia",
            "Endócrino | Metabolismo"
        ]
    },
    {
        "class": "Mineralocorticoides",
        "systems": [
            "Endócrino | Metabolismo"
        ]
    },
    {
        "class": "Imunomoduladores",
        "systems": [
            "Imunossupressores | Imunomoduladores"
        ]
    },
    {
        "class": "Retinóides",
        "systems": [
            "Dermatológicos Não Tópicos"
        ]
    },
    {
        "class": "Antirreumáticos",
        "systems": [
            "Musculoesqueléticos | Articulares"
        ]
    },
    {
        "class": "Antidiarreicos",
        "systems": [
            "Gastrointestinais"
        ]
    },
    {
        "class": "Antieméticos",
        "systems": [
            "Gastrointestinais",
            "Neurológicos | Comportamentais"
        ]
    },
    {
        "class": "Progestágenos e Supressores de Estro",
        "systems": [
            "Endócrino | Metabolismo",
            "Reprodução | Obstetrícia"
        ]
    },
    {
        "class": "Inibidores da Adrenocortical",
        "systems": [
            "Endócrino | Metabolismo"
        ]
    },
    {
        "class": "Reversores/Antagonistas Opioides",
        "systems": [
            "Emergência | Intensivismo",
            "Anestesia | Sedação | Adjuvantes"
        ]
    },
    {
        "class": "Anticolinesterásicos: Manejo de Miastenia Gravis",
        "systems": [
            "Musculoesqueléticos | Articulares",
            "Neurológicos | Comportamentais"
        ]
    },
    {
        "class": "Eméticos",
        "systems": [
            "Gastrointestinais",
            "Emergência | Intensivismo"
        ]
    },
    {
        "class": "Antifiséticos",
        "systems": [
            "Gastrointestinais"
        ]
    },
    {
        "class": "Protetores de Mucosa do TGI",
        "systems": [
            "Gastrointestinais"
        ]
    },
    {
        "class": "Eutanásicos",
        "systems": [
            "Diversos"
        ]
    },
    {
        "class": "Expansores Plasmáticos",
        "systems": [
            "Emergência | Intensivismo",
            "Cardiovasculares"
        ]
    },
    {
        "class": "Imunoterápicos Dermatológicos",
        "systems": [
            "Dermatológicos Não Tópicos",
            "Alergias | Hipersensibilidade"
        ]
    },
    {
        "class": "Antigalactogênicos",
        "systems": [
            "Reprodução | Obstetrícia"
        ]
    },
    {
        "class": "Suporte de Osteoartrite/Osteoartrose",
        "systems": [
            "Musculoesqueléticos | Articulares"
        ]
    },
    {
        "class": "Enzimas Digestivas",
        "systems": [
            "Gastrointestinais"
        ]
    },
    {
        "class": "Manejo da Leishmaniose",
        "systems": [
            "Antimicrobianos | Antiparasitários"
        ]
    },
    {
        "class": "Estimulantes do SNC e Nootrópicos",
        "systems": [
            "Neurológicos | Comportamentais"
        ]
    },
    {
        "class": "Potencializadores de Perfusão Tissular",
        "systems": [
            "Neurológicos | Comportamentais",
            "Cardiovasculares"
        ]
    },
    {
        "class": "Inibidores de Janus Kinase",
        "systems": [
            "Dermatológicos Não Tópicos",
            "Alergias | Hipersensibilidade"
        ]
    },
    {
        "class": "Análogos da Somatostatina",
        "systems": [
            "Endócrino | Metabolismo"
        ]
    },
    {
        "class": "Hormônios Tireoidianos",
        "systems": [
            "Endócrino | Metabolismo"
        ]
    },
    {
        "class": "Manejo da Inércia Uterina",
        "systems": [
            "Reprodução | Obstetrícia"
        ]
    },
    {
        "class": "Luteinizantes",
        "systems": [
            "Reprodução | Obstetrícia"
        ]
    },
    {
        "class": "Anticolinesterásicos",
        "systems": [
            "Emergência | Intensivismo"
        ]
    }
];